import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import PopEditElement from './PopEditElement';
import { Input as DesignInput } from '@whalecloud/fdx';
import { popEditRegExp } from '@utils/util';

const left = css({ textAlign: 'left' });
const Participant = props => {
  const { element, nameSpace } = props;
  const { formSettings, formItemSettings, settings, className = '' } = element.data;
  const { rules = [] } = formSettings;
  const { horizontalAlign = 'left' } = settings;
  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required }]
  }
  const eventProps = makeEventProps(element.data.events, nameSpace);

  const InputInPopedit=({value,onChange,...rest})=>{
    onChange(value||((formItemSettings.defaultValue?.[formItemSettings.dataTextField])?formItemSettings.defaultValue:undefined))
    return <DesignInput {...formItemSettings} value={value?.[formItemSettings.dataTextField]||formItemSettings.defaultValue?.[formItemSettings.dataTextField]} {...rest} readonly/>
  }

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          {!eventProps?.onClick?.openModal&&
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-participant', left)}
            {...formSettings}
            {...ruleProps}
          >
            <PopEditElement element={element} {...eventProps} className={className} />
          </FormItem>}
          {eventProps?.onClick?.openModal&&
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-participant', left)}
            {...formSettings}
            {...ruleProps}
          >
            <InputInPopedit {...eventProps} className={className}/>
          </FormItem>}
        </div>
      )}
    </ElementRoot>
  );
};

export default Participant;
